module.exports = __webpack_public_path__ + "src/content/gifs/white1.gif";